export var Status;
(function (Status) {
    Status[Status["ONLINE"] = 1] = "ONLINE";
    Status[Status["OFFLINE"] = 2] = "OFFLINE";
})(Status || (Status = {}));
export var OnlineStatusType;
(function (OnlineStatusType) {
    OnlineStatusType[OnlineStatusType["VIEWING"] = 1] = "VIEWING";
    OnlineStatusType[OnlineStatusType["INTERACTING"] = 2] = "INTERACTING";
    OnlineStatusType[OnlineStatusType["HIDDEN"] = 3] = "HIDDEN";
})(OnlineStatusType || (OnlineStatusType = {}));
export var PubSubPresenceStatusType;
(function (PubSubPresenceStatusType) {
    PubSubPresenceStatusType[PubSubPresenceStatusType["VIEWING"] = 1] = "VIEWING";
    PubSubPresenceStatusType[PubSubPresenceStatusType["INTERACTING"] = 2] = "INTERACTING";
    PubSubPresenceStatusType[PubSubPresenceStatusType["HIDDEN"] = 3] = "HIDDEN";
    PubSubPresenceStatusType[PubSubPresenceStatusType["OFFLINE"] = 5] = "OFFLINE";
})(PubSubPresenceStatusType || (PubSubPresenceStatusType = {}));
export var DEFAULT_TYPING_TIMEOUT = 5000;
export var PRESENCE_EVENT = 'presence';
export var getChannelName = function (tenantName, itemId) { return "".concat(tenantName, "-").concat(itemId); };
export var pubsubStatusToPresence = function (pubsubStatus) {
    var status = pubsubStatus.status;
    var location = pubsubStatus.location || { url: '', title: '' };
    switch (status) {
        case PubSubPresenceStatusType.OFFLINE:
            return { type: Status.OFFLINE };
        case PubSubPresenceStatusType.VIEWING:
            return { type: Status.ONLINE, data: OnlineStatusType.VIEWING, location: location };
        case PubSubPresenceStatusType.INTERACTING:
            return { type: Status.ONLINE, data: OnlineStatusType.INTERACTING, user: pubsubStatus.user, location: location };
        case PubSubPresenceStatusType.HIDDEN:
            return { type: Status.ONLINE, data: OnlineStatusType.HIDDEN, location: location };
    }
};
//# sourceMappingURL=utils.js.map